import { clearLoggedInUser } from "./Redux/Auth/AuthSlice";

export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    (config) => {
      const { Auth } = store.getState();
      config.baseURL = process.env.REACT_APP_API_BASEURL;
      config.headers.Accept = "*/*";
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";

      if (
        Auth.loggedInUser &&
        Auth.loggedInUser.data &&
        Auth.loggedInUser.data.token
      ) {
        config.headers.Authorization = "Bearer " + Auth.loggedInUser.data.token;
      }
      return config;
    },
    (err) => Promise.reject(err)
  );
  //   Response interceptor for API calls
  axios.interceptors.response.use(
    (response) => response,
    async function (error) {
      if (error.response.status === 401) {
        const { Auth } = store.getState();
        const refreshToken = Auth?.loggedInUser?.data?.refreshToken;

        if (refreshToken) {
          try {
            // Try refreshing the token
            const newTokenResponse = await axios.post(
              process.env.REACT_APP_API_BASEURL + "/refresh-token",
              { refresh_token: refreshToken }
            );

            // Save new token in Redux
            store.dispatch({
              type: "auth/updateToken",
              payload: newTokenResponse.data.token,
            });

            // Retry the failed request with new token
            error.config.headers.Authorization =
              "Bearer " + newTokenResponse.data.token;
            return axios(error.config);
          } catch (refreshError) {
            store.dispatch(clearLoggedInUser()); // If refresh fails, logout
          }
        } else {
          store.dispatch(clearLoggedInUser());
        }
      }
      return Promise.reject(error);
    }
  );
}
